import gql from 'graphql-tag'

export const getQuotes = gql`
  query($paging: PagingQuery, $order: QuotesOrder, $filter: QuotesFilter!) {
    getQuotes(
      filter: $filter,
      order: $order,
      paging: $paging
    ) {
      quotes {
        id
        name
        status
        type
        originalInceptionDate
        closed
        createdAt
        updatedAt
        additionalInfoStr
        account {
          id
          name
        }
        primaryContact {
          id
          name
        }
        source {
          id
          name
        }
        carrierProduct {
          id
          name
        }
        recordType {
          id
          name
        }
        priorTerm {
          id
          policyName
        }
        createdBy {
          id
          username
        }
        lastModifiedBy {
          id
          username
        }
      }
      paging{ totalCount currentOffset currentLimit }
    }
  }
`

export const getCandidateQuotes = gql`
  query($paging: PagingQuery, $filter: QuotesFilter!) {
    getQuotes(
      filter: $filter,
      paging: $paging
    ) {
      quotes {
        id
        name
      }
    }
  }
`

export const getQuote = gql`
  query($quoteId: Int!) {
    getQuote(
      quoteId: $quoteId
    ) {
      id
      name
      status
      type
      originalInceptionDate
      closed
      createdAt
      updatedAt
      additionalInfoStr
      caseId
      caseInfo {
        type
      }
      account {
        id
        name
        book {
          id
          name
        }
      }
      primaryContact {
        id
        name
      }
      source {
        id
        name
      }
      carrierProduct {
        id
        name
      }
      recordType {
        id
        name
      }
      assignedUsers {
        id
        username
      }
      premiums {
        id
        carrierId
        carrierName
        gaId
        gaName
        effectiveDate
        term
        expirationDate
        closeDate
        installmentPlan
        billingType
        payerType
        premium
        agencyFee
        carrierPolicyFee
        inspectionFee
        stampingFee
        brokerFee
        taxesFee
        commission
        deniedReasons
        ifDenied
        createdAt
        updatedAt
        totalAmount
        totalProjectCommission
      }
      createdBy {
        id
        username
      }
      lastModifiedBy {
        id
        username
      }
      insureds {
        id
        name
        relationShip
        dateOfBirth
      }
      vehicles {
        id
        name
        vin
        year
        make
        loan
        model
        notes
        vehicleCoverage
        ownership
        useage
        mileage
        roadsideTowing
        rentalCarCoverage
        createdAt
        updatedAt
        quote {
          id
          name
        }
        policy {
          id
          policyName
        }
        lienHolder {
          id
          name
        }
      }
      properties {
        id
        address
        city
        state
      }
      labels {
        id
        content
        color
      }
      policies {
        id
        policyName
        status
        type
        effectiveDate
        expirationDate
        originalInceptionDate
        brokerFee
        agencyFee
        carrierPolicyFee
        inspectionFee
        taxesFee
        stampingFee
        premium
        policyNumber
        term
        bindDate
        payerType
        closed
        nonRenew
        shouldAutoCancel
        cancelDate
        createdAt
        updatedAt
        productCommissionOverride
        caseId
        additionalInfoStr
        installmentPlan
        billingType
        isPremiumPayOff
        isCommissionPayOff
        totalProjectedPremium
        totalProjectedCommission
        account {
          id
          name
        }
        primaryContact {
          id
          name
        }
        source {
          id
          name
        }
        carrier {
          id
          name
        }
        carrierProduct {
          id
          name
        }
        generalAgent {
          id
          name
        }
        book {
          id
          name
        }
        recordType {
          id
          name
        }
        insuranceQuote {
          id
          name
        }
        writingAgents {
          id
          username
        }
        inheritPolicies {
          fromPolicy {
            id
            policyName
          }
        }
      }
      acordForms {
        id
        notes
        name
        size
        version
        url
        lockedUrl
        createdAt
        acordFormId
      }
      attachments {
        id
        type
        name
        size
        createdAt
        updatedAt
      }
      priorTerm {
        id
        policyName
        status
        type
        effectiveDate
        expirationDate
        originalInceptionDate
        brokerFee
        agencyFee
        carrierPolicyFee
        inspectionFee
        taxesFee
        stampingFee
        premium
        policyNumber
        term
        bindDate
        payerType
        closed
        nonRenew
        shouldAutoCancel
        cancelDate
        createdAt
        updatedAt
        productCommissionOverride
        caseId
        additionalInfoStr
        installmentPlan
        billingType
        isPremiumPayOff
        isCommissionPayOff
        totalProjectedPremium
        totalProjectedCommission
        account {
          id
          name
        }
        primaryContact {
          id
          name
        }
        source {
          id
          name
        }
        carrier {
          id
          name
        }
        carrierProduct {
          id
          name
        }
        generalAgent {
          id
          name
        }
        book {
          id
          name
        }
        recordType {
          id
          name
        }
        insuranceQuote {
          id
          name
        }
        writingAgents {
          id
          username
        }
        inheritPolicies {
          toPolicy {
            id
            policyName
          }
        }
      }
    }
  }
`

export const getQuotePremiums = gql`
  query($quoteId: Int!) {
    getQuotePremiums(
      quoteId: $quoteId
    ) {
      id
      carrierId
      carrierName
      gaId
      gaName
      effectiveDate
      term
      expirationDate
      installmentPlan
      billingType
      payerType
      premium
      agencyFee
      carrierPolicyFee
      inspectionFee
      stampingFee
      brokerFee
      taxesFee
      commission
      createdAt
      updatedAt
      totalAmount
      totalProjectCommission
    }
  }
`

export const newQuote = gql`
  mutation($quoteInput: QuoteInput!) {
    newQuote(
      quoteInput: $quoteInput
    ) {
      id,
      name
    }
  }
`

export const editQuote = gql`
  mutation($quoteInput: QuoteInput!, $quoteId: Int!) {
    editQuote(
      quoteId: $quoteId,
      quoteInput: $quoteInput
    ) {
      id,
      name
    }
  }
`

export const deleteQuote = gql`
  mutation($quoteId: Int!) {
    deleteQuote(
      quoteId: $quoteId
    )
  }
`

export const updateQuoteLabels = gql`
  mutation($labelIds: [Int!]!, $quoteId: Int!) {
    updateQuoteLabels(
      labelIds: $labelIds,
      quoteId: $quoteId
    ) {
      id
    }
  }
`

export const newQuotePremium = gql`
  mutation($input: NewQuotePremiumInput!) {
    newQuotePremium(
      input: $input
    ) {
      id
      carrierId
      carrierName
      gaId
      gaName
      effectiveDate
      term
      expirationDate
      installmentPlan
      billingType
      payerType
      closeDate
      premium
      agencyFee
      carrierPolicyFee
      inspectionFee
      stampingFee
      brokerFee
      taxesFee
      commission
      createdAt
      updatedAt
      totalAmount
      totalProjectCommission
    }
  }
`

export const editQuotePremium = gql`
  mutation($input: EditQuotePremiumInput!, $relationId: Int!) {
    editQuotePremium(
      input: $input
      relationId: $relationId
    ) {
      id
      carrierId
      carrierName
      gaId
      gaName
      effectiveDate
      term
      expirationDate
      installmentPlan
      billingType
      closeDate
      premium
      agencyFee
      carrierPolicyFee
      inspectionFee
      stampingFee
      brokerFee
      taxesFee
      commission
      createdAt
      updatedAt
      totalAmount
      totalProjectCommission
    }
  }
`

export const assignQuote = gql`
  mutation($quoteId: Int!, $userIds: [Int!]!) {
    assignQuote(
      quoteId: $quoteId,
      userIds: $userIds,
    )
  }
`

export const deleteQuotePremium = gql`
  mutation($quoteId: Int!, $gaId: Int, $carrierId: Int, $relationId: Int) {
    deleteQuotePremium(
      quoteId: $quoteId,
      gaId: $gaId,
      carrierId: $carrierId,
      relationId: $relationId
    )
  }
`

export const createQuoteRequests = gql`
  mutation($inputs: [QuoteRequestInput!]!, $quoteId: Int!) {
    createQuoteRequests(
      inputs: $inputs,
      quoteId: $quoteId
    )
  }
`

export const getGlobalSearchQuotes = gql`
  query($query: String!, $order: QuotesOrder!, $paging: PagingQuery!) {
    globalSearchQuotes(
      query: $query,
      order: $order,
      paging: $paging
    ) {
      quotes {
        id
        name
      }
    }
  }
`

export const getAllGlobalSearchQuotes = gql`
  query($query: String!, $order: QuotesOrder!, $paging: PagingQuery!) {
    globalSearchQuotes(
      query: $query,
      order: $order,
      paging: $paging
    ) {
      quotes {
        id
        name
        account {
          id
          name
        }
        primaryContact {
          id
          name
        }
        status
        type
      }
      paging{ totalCount currentOffset currentLimit }
    }
  }
`

export const updateDeniedReasons = gql`
  mutation($relationId: Int!, $ifDenied: Boolean!, $deniedReasons: String) {
    updateDeniedReasons(
      relationId: $relationId,
      ifDenied: $ifDenied,
      deniedReasons: $deniedReasons,
    )
  }
`
